import { createFileRoute } from "@tanstack/react-router";
import AdminSolutions from "@/pages/admin/AdminSolutions";

export const Route = createFileRoute("/admin/soluciones")({ component: AdminSolutions });
